<template>
  <FullScreenModal :open="open" @close="handleClose">
    <div class="max-w-3xl mx-auto w-full">
      <div v-if="!consentResult" class="px-4 pt-6">
        <StepProgressBar :current-step="currentStep" :total-steps="4" />
      </div>

      <InformationStep v-if="currentStep === 1" :remaining-days="remainingDays" @next="currentStep = 2" />

      <ComparisonStep v-else-if="currentStep === 2" :plan="plan" @next="currentStep = 3" @previous="currentStep = 1" />

      <DocumentAcknowledgmentStep
        v-else-if="currentStep === 3"
        :plan="plan"
        @next="currentStep = 4"
        @previous="currentStep = 2"
      />

      <ChoiceStep
        v-else-if="currentStep === 4 && !consentResult"
        :loading="isSubmitting"
        :selected-choice="selectedChoice"
        @select-choice="selectedChoice = $event"
        @confirm="handleConfirm"
        @previous="currentStep = 3"
      />

      <AcceptanceConfirmation v-else-if="consentResult === 'accepted'" @close="handleClose" />

      <CancellationConfirmation v-else-if="consentResult === 'refused'" @close="handleClose" />
    </div>
  </FullScreenModal>
</template>

<script>
import { FullScreenModal } from "@estaly/ui";
import { mapActions, mapGetters } from "vuex";
import StepProgressBar from "./StepProgressBar.vue";
import InformationStep from "./steps/InformationStep.vue";
import ComparisonStep from "./steps/ComparisonStep.vue";
import DocumentAcknowledgmentStep from "./steps/DocumentAcknowledgmentStep.vue";
import ChoiceStep from "./steps/ChoiceStep.vue";
import AcceptanceConfirmation from "./steps/AcceptanceConfirmation.vue";
import CancellationConfirmation from "./steps/CancellationConfirmation.vue";

export default {
  components: {
    FullScreenModal,
    StepProgressBar,
    InformationStep,
    ComparisonStep,
    DocumentAcknowledgmentStep,
    ChoiceStep,
    AcceptanceConfirmation,
    CancellationConfirmation,
  },

  props: {
    open: {
      type: Boolean,
      required: true,
    },
    consent: {
      type: Object,
      default: null,
    },
    plan: {
      type: Object,
      default: null,
    },
  },

  emits: ["close"],

  data() {
    return {
      currentStep: 1,
      consentResult: null,
      isSubmitting: false,
      selectedChoice: null,
    };
  },

  computed: {
    ...mapGetters("contractMigrationConsents", { remainingDaysGetter: "remainingDays" }),
    remainingDays() {
      if (!this.consent) return 0;
      return this.remainingDaysGetter(this.consent);
    },
  },

  methods: {
    ...mapActions("contractMigrationConsents", ["respondToConsent"]),

    async handleConfirm(status) {
      this.isSubmitting = true;
      const response = await this.respondToConsent({ id: this.consent.id, status });
      if (response?.success) {
        this.consentResult = status;
      }
      this.isSubmitting = false;
    },

    handleClose() {
      this.currentStep = 1;
      this.consentResult = null;
      this.selectedChoice = null;
      this.$emit("close");
    },
  },
};
</script>
